import { Auth } from 'aws-amplify';

export function confirmEmailAPI(email) {
  return Auth.signIn(email, '123');
}
